'use strict';

var toastr = require('toastr');
var SystemStatusOverbookingController = function SystemStatusOverbookingController($scope, $state, dataRetrieverService, systemStatusCommonRendererFactory, dataRetrieverConstantsService, overbookingService, $q, SearchCriteriaRule, configurationService, $log) {
  function postColumnsSuccessHandler() {
    toastr.success('Successfully saved configuration changes.');
  }
  function postColumnsErrorHandler(response) {
    var errorMsg = 'Error when saving configuration changes. ' + response.statusText + ' (code ' + response.status + ')';
    $log.error('SystemStatusOverbookingController: postColumnsErrorHandler - ' + errorMsg);
    toastr.error(errorMsg);
    return $q.reject();
  }
  function reloadData() {
    $scope.$broadcast('grid:dataChanged');
  }
  $scope.forceAddRow = function () {
    var eventName = 'reinit-overbooking:force-add-row';
    var data = $state.params.transitionData;
    if (data) {
      var rowData = data[eventName];
      if (rowData) {
        $scope.$broadcast(eventName, rowData);
        data[eventName] = undefined;
      }
    }
  };
  function getSearchCriteria() {
    var ruleParams = {
      category: 'System Status',
      criterion: 'reinitializationOverbookingQueue',
      metaCategory: 'carrier',
      operator: '=',
      field: 'events[].carrier',
      searchContext: '',
      leftOperand: configurationService.getHostCarrier()
    };
    var ruleParams2 = {
      category: 'System Status',
      criterion: 'reinitializationOverbookingQueue',
      metaCategory: 'initType',
      operator: '!=',
      field: 'events[].initializationType',
      searchContext: '',
      leftOperand: 'LEARNING'
    };
    var ruleParams3 = {
      category: 'System Status',
      criterion: 'reinitializationQueue',
      metaCategory: 'calendarName',
      operator: '=',
      field: 'events[].calendarName',
      searchContext: '',
      leftOperand: 'ReInitShowup'
    };
    return [new SearchCriteriaRule(ruleParams), new SearchCriteriaRule(ruleParams2), new SearchCriteriaRule(ruleParams3)];
  }
  dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.SYSTEM_STATUS_SCREEN, dataRetrieverConstantsService.SYSTEM_STATUS_OVERBOOKING_MODE).setCustomSearchCriteriaRules(getSearchCriteria());
  $scope.reinitialize = function (event, rows) {
    overbookingService.reinitializeFromStatusScreen(rows).then(postColumnsSuccessHandler, postColumnsErrorHandler).then(reloadData);
  };
  $scope.customRenderers = systemStatusCommonRendererFactory;
};
SystemStatusOverbookingController.$inject = ['$scope', '$state', 'DataRetrieverService', 'SystemStatusCommonRendererFactory', 'DataRetrieverConstantsService', 'OverbookingService', '$q', 'SearchCriteriaRuleFactory', 'ConfigurationService', '$log'];
module.exports = SystemStatusOverbookingController;